module.exports = __webpack_public_path__ + "img/gpac.0b6e1519.png";